import { ref, push, getDatabase } from "firebase/database";
import { toastrError } from "../components/toastr";

async function addUser(payload) {
  try {
    const database = getDatabase();
    const customersRef = ref(database, "customers");
    await push(customersRef, payload);
    return true;
  } catch (err) {
    toastrError("Failed to add customer");
    throw err;
  }
}

export { addUser };
